export default "__VITE_PUBLIC_ASSET__0b86b952__"